import React from "react";

const ConfirmIcon = (props) => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M3 9.23438L7.24264 13.477L15.7279 4.99174"
				stroke="#EFF0F6"
				stroke-width="2"
				stroke-linecap="round"
			/>
		</svg>
	);
};

export default ConfirmIcon;
